import type { Account } from "../../lib/convexApi";

export function destinationAccountId(accounts: Account[], fromAccountId: string, currentToAccountId: string): string {
  const currentDestinationIsValid = currentToAccountId !== fromAccountId && accounts.some((account) => account._id === currentToAccountId);
  return currentDestinationIsValid ? currentToAccountId : accounts.find((account) => account._id !== fromAccountId)?._id ?? "";
}

export function transferLabel(accounts: Account[], fromAccountId: string, toAccountId: string, description: string): string {
  if (description.trim()) return description.trim();
  const from = accounts.find((account) => account._id === fromAccountId)?.name;
  const to = accounts.find((account) => account._id === toAccountId)?.name;
  return from && to ? `${from} → ${to}` : "Account transfer";
}
